const newScratchpad = `data:image/svg+xml;utf8,
<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
  <g transform="matrix(1.592859, 0, 0, 1.592859, 80.618149, -375.239136)" style="">
    <title>Plus</title>
    <title>Add</title>
    <path stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" d="M 178.569 259.075 L 178.569 383.277 M 240.67 321.176 L 116.468 321.176" style="stroke-width: 17.5785px;"/>
  </g>
  <g fill="currentColor" transform="matrix(15.405798, 0, 0, 15.405798, -10557.493164, -4172.518555)" style="">
    <rect style="" transform="matrix(0.707107, 0.707107, -0.707107, 0.707107, 409.316132, -411.129639)" x="696.444" y="283.741" width="7.789" height="7.789" rx="1.039" ry="1.039"/>
    <rect style="" x="697.049" y="293.955" width="7.789" height="7.789" rx="1.039" ry="1.039"/>
    <rect style="" x="686.871" y="283.777" width="7.789" height="7.789" rx="1.039" ry="1.039"/>
    <rect style="" x="686.871" y="293.955" width="7.789" height="7.789" rx="1.039" ry="1.039"/>
  </g>
</svg>`;

export { newScratchpad };
